import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, } from "react-router-dom";

import Homepage from '../HomePage4'
import AboutPage from '../AboutPage'
import ServicePage from '../ServicePage';
import ServiceSinglePage from '../ServiceSinglePage';
import ProjectPage from '../ProjectPage';
import ProjectSinglePage from '../ProjectSinglePage';
import TeamSinglePage from '../TeamSinglePage';
import BlogPage from '../BlogPage'
import BlogDetails from '../BlogDetails'
import ContactPage from '../ContactPage'
import ErrorPage from '../ErrorPage'
import { useTranslation } from 'react-i18next';
import { LanguageProvider } from '../../context/LanguageContext';
import Terms from '../terms';
import Privacy from '../privacy';
const AllRoute = () => {
  const { i18n } = useTranslation();
  useEffect(() => {
    document.dir = i18n.language === "en" ? "ltr" : "rtl"
  }, [i18n.language])
  return (
    <LanguageProvider>
      <BrowserRouter>
        <Routes>
          <Route exact path='/' element={<Homepage />} />
          <Route path='home' element={<Homepage />} />
          <Route path='about' element={<AboutPage />} />
          <Route path='project-single/:id' element={<ProjectSinglePage />} />
          <Route path='service-single/:id' element={<ServiceSinglePage />} />
          <Route path='team-single/:id' element={<TeamSinglePage />} />
          <Route path='service' element={<ServicePage />} />
          <Route path='project' element={<ProjectPage />} />
          <Route path='contact' element={<ContactPage />} />
          <Route path='terms' element={<Terms />} />
          <Route path='privacy' element={<Privacy />} />
          <Route path='404' element={<ErrorPage />} />
          <Route path='blog-single/:id' element={<BlogDetails />} />
          <Route path='blog' element={<BlogPage />} />
        </Routes>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default AllRoute;
